import './opportunityList.scss';
import {CalculationNotificationServiceName} from "../../../utils/names/serviceNames";
import {Opportunity, OpportunityEventType} from "../../model/Opportunity";
import {IComponentController} from "angular";
import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {Subscription} from "rxjs";

interface OpportunityListScope {
    opportunities: Opportunity[];

}

export class OpportunityList implements IComponentController {

    static instance = {
        controller: [
            '$scope',
            CalculationNotificationServiceName,
            OpportunityList
        ],
        template: require('./opportunityList.html'),
        bindings: {
            opportunities: '<'
        }
    };

    private subscription: Subscription;
    private opportunities: Opportunity[] = [];

    constructor(private $scope: OpportunityListScope,
                private notificationsService: CalculationsNotificationService) {
    }

    $onInit = () => {
        this.$scope.opportunities = this.opportunities;
        this.subscribeForOpportunityEvents();
    };

    $onChanges = changesObj => {
        console.log('Opportunity list changes');
        if (changesObj && changesObj.opportunities && !changesObj.opportunities.isFirstChange()) {
            this.$scope.opportunities = changesObj.opportunities.currentValue;
        }
    };

    $onDestroy(): void {
        this.subscription.unsubscribe();
    }

    subscribeForOpportunityEvents = () => {
        this.subscription = this.notificationsService.subscribeForOpportunityEvents()
            .subscribe((event) => {
                switch (event.eventType) {
                    case OpportunityEventType.REMOVED:
                        this.removeNotificationFromTheList(event.opportunity);
                }
            })
    };

    removeNotificationFromTheList = (opportunity: Opportunity) => {
        let opportunityIndex: number = this.$scope.opportunities.findIndex(o => opportunity.id === o.id);
        this.$scope.opportunities.splice(opportunityIndex, 1);
    };


}